export enum StudentTicketChangeType {
  PAYMENT_INFORMATION = 'PAYMENT_INFORMATION',
  ADDRESS_DATA = "ADDRESS_DATA",
  SCHOOL_DATA = "SCHOOL_DATA",
  NAME_DATA = "NAME_DATA",
}
